import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

export function createMaterial(data) {
  return request({
    url: `${v2Host}/res_store/create`,
    method: 'post',
    data: cookRequestParams(data)
  })
}
